import { FC, ReactNode } from "react";
import { Flex, Title, useMantineTheme } from "@mantine/core";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { useMetaDescription } from "../hooks/useMetaDescription";

interface PageTitleProps {
  icon: ReactNode;
  children: ReactNode;
  documentTitle?: string;
  metaDescription?: string;
}

export const PageTitle: FC<PageTitleProps> = ({
  icon,
  children,
  documentTitle,
  metaDescription,
}) => {
  const theme = useMantineTheme();

  const effectiveDocumentTitle =
    documentTitle ?? (typeof children === "string" ? children : undefined);
  useDocumentTitle(effectiveDocumentTitle);
  useMetaDescription(metaDescription);

  return (
    <Flex align="center" gap="xs">
      <Flex
        c={theme.colors.fwcBlue?.[6] ?? theme.colors.blue[6]}
        style={{ flexShrink: 0 }}
      >
        {icon}
      </Flex>
      <Title order={2}>{children}</Title>
    </Flex>
  );
};
